import styled from "styled-components";
import { Image } from "../common/image";
import { useEffect, useState } from "react";
import CustomInputComponent from "../common/customInputComponent";
import ItemComponent from "./itemComponent";
import SpaceBox from "../common/spaceBox";
import { text } from "stream/consumers";
import CustomButton from "../common/customButton";
import { categoryList } from "../../types/types";
import AddItemModal from "./addItemModal";

const Wrapper = styled.div<{
  $isExpanded?: boolean;
}>`
  background-color: white;
  width: 100%;
  height: 100%;
  margin-bottom: 2vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* border-bottom-left-radius: 1vw;
  border-bottom-right-radius: 1vw; */
  border-radius: 1vw;
  box-shadow: 3px 3px 20px -10px #16161642;
  outline: ${(props) => (props.$isExpanded ? "0.3vw solid #ff7f3b" : "none")};
`;

const Backdrop = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000050;
  z-index: 9998; /* 모달보다 아래에 위치하도록 설정합니다. */
`;

const DisplayBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const MetaBox = styled.div`
  display: flex;
  justify-content: start;
  align-items: end;
  height: 8vw;
  width: 90vw;
  margin-bottom: 0.8vw;
`;

const ImageBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6vw;
  height: 6vw;
  background-color: #ff7f3b;
  border-radius: 100%;
  margin-right: 2vw;
`;

const TitleBox = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  width: 38vw;
  height: 6vw;
  margin-right: 4vw;
`;

const MetaDataBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 34vw;
  height: 6vw;
  margin-right: 2vw;
`;

const SettingBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3vw;
  height: 6vw;
`;

const ExpandButtonBox = styled.div`
  width: 100%;
  height: 2vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ButtonImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30vw;
  height: 100%;
  border-bottom: 0.6vw solid #ff7f3b;
`;

const ExpandedBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: 5vw;
`;

const CBMBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  width: 22vw;
  height: 7vw;
`;

const Title = styled.p`
  font-size: 2.4vw;
  font-weight: 600;
  height: 4vw;
  display: flex;
  align-items: center;
  margin-right: 0.4vw;
`;
const Subtitle = styled.p`
  font-size: 1.2vw;
  font-weight: 300;
  height: 3vw;
  display: flex;
  align-items: end;
`;

const SubText = styled.p`
  font-size: 1.4vw;
  font-weight: 400;
  height: 2vw;
  display: flex;
  align-items: center;
  margin-left: 1vw;
`;

const InputArea = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 5vw;
`;

const InputBox = styled.div`
  display: flex;
  justify-content: center;
  width: 12vw;
  height: 78%;
  background-color: #f4f4f4;
  border-radius: 0.4vw;
`;

const InputNumber = styled.p`
  display: flex;
  justify-content: end;
  align-items: center;
  font-size: 2.4vw;
  font-weight: 500;
  width: 86%;
`;

const Line = styled.div`
  width: 90vw;
  height: 1vw;
  border-bottom: 0.1vw dashed #d8d8d8;
`;

const ItemListArea = styled.div`
  width: 90vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ItemComponentBox = styled.div`
  width: 100%;
  height: 7.8vw;
  background-color: #f4f4f4;
  border-radius: 0.4vw;
  margin-top: 1.2vw;
`;

const ItemHeaderBox = styled.div`
  width: 90vw;
  height: 5vw;
  margin-top: 1vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AddItemButtonBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15%;
  height: 100%;
`;

export default function SpaceComponent(props: any) {
  const { data, setData, deleteSpace, deleteItem, currentPage } = props;
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [openAddItemModal, setOpenAddItemModal] = useState<boolean>(false);
  const categoryData = categoryList;

  const onclickDeleteSpace = (id: number) => {
    if (!window.confirm("해당 공간을 정말삭제하시겠습니까?")) {
      return;
    }
    deleteSpace(id);
  };

  // 물품이 추가되면 통계 값을 변경하는 함수
  const recalculateTotal = (roomId: number) => {
    setData((prev: any) => {
      const updatedData = { ...prev };

      let quantity = 0;
      let cbm = 0;
      updatedData.chargeList[currentPage - 1].roomList[
        roomId - 1
      ].itemList.forEach((item: any) => {
        quantity += Number(item.quantity);
        cbm += Number(item.cbm);
      });

      updatedData.chargeList[currentPage - 1].roomList[roomId - 1].quantity =
        quantity;
      updatedData.chargeList[currentPage - 1].roomList[roomId - 1].cbm =
        cbm.toFixed(2);

      return updatedData;
    });
  };

  // 선택된 물품을 추가하는 함수
  const addNewItem = (
    categoryType: number,
    selectedItem: any,
    itemName: string,
    quantity: number,
    cbm: number,
    carryType: number
  ) => {
    const lastId = data.itemList.length;
    let newData = {
      id: lastId + 1,
      itemCode: selectedItem.typeName,
      category: categoryData[categoryType - 1].categoryName,
      item: itemName,
      quantity: quantity,
      cbm: cbm,
      carryType: carryType,
      isCustom: selectedItem.isCustom,
    };

    setData((prev: any) => {
      const updatedData = { ...prev };

      updatedData.chargeList[currentPage - 1].roomList[data.id - 1].itemList = [
        ...updatedData.chargeList[currentPage - 1].roomList[data.id - 1]
          .itemList,
        newData,
      ];

      return updatedData;
    });
  };

  useEffect(() => {
    recalculateTotal(data.id);
  }, [data.itemList]);

  const onClickAddItem = () => {
    setOpenAddItemModal(true);
  };

  const onCloseAddItemModal = () => {
    setOpenAddItemModal(false);
  };

  return (
    <>
      <Wrapper $isExpanded={isExpanded}>
        <DisplayBox>
          <MetaBox>
            <ImageBox onClick={() => setIsExpanded(!isExpanded)}>
              <Image
                src={`/icon/enterprise${data.type}.png`}
                alt="아이콘"
                width={"50%"}
                height={"50%"}
              />
            </ImageBox>
            <TitleBox onClick={() => setIsExpanded(!isExpanded)}>
              <Title>{data.name}</Title>
              <Subtitle>/{data.typeName}</Subtitle>
            </TitleBox>
            <MetaDataBox onClick={() => setIsExpanded(!isExpanded)}>
              <CBMBox>
                <InputArea>
                  <InputBox>
                    <InputNumber>{data.quantity}</InputNumber>
                  </InputBox>
                  <SubText>개</SubText>
                </InputArea>
              </CBMBox>
              <CBMBox>
                <InputArea>
                  <InputBox>
                    <InputNumber>{data.cbm}</InputNumber>
                  </InputBox>
                  <SubText>CBM</SubText>
                </InputArea>
              </CBMBox>
            </MetaDataBox>
            <SettingBox onClick={() => onclickDeleteSpace(data.id)}>
              {/* 세팅박스로 구현하기 전 임시 조치 */}
              <Image
                src={`/icon/delete.png`}
                width={"2.4vw"}
                height={"2.4vw"}
              ></Image>
              {/* <Image
                src={`/icon/setting.png`}
                width={"4.4vw"}
                height={"4.4vw"}
              ></Image> */}
            </SettingBox>
          </MetaBox>
        </DisplayBox>
        {isExpanded && (
          <ExpandedBox>
            <Line></Line>
            <ItemListArea>
              <ItemHeaderBox>
                <SpaceBox
                  width={"36%"}
                  height={"100%"}
                  text={"물품명"}
                  justifyContent={"start"}
                  paddingLeft={"2vw"}
                ></SpaceBox>
                <SpaceBox
                  width={"15%"}
                  height={"100%"}
                  text={"수량"}
                ></SpaceBox>
                <SpaceBox
                  width={"15%"}
                  height={"100%"}
                  text={"부피(cbm)"}
                ></SpaceBox>
                <SpaceBox
                  width={"15%"}
                  height={"100%"}
                  text={"처리방법"}
                ></SpaceBox>
                <AddItemButtonBox onClick={onClickAddItem}>
                  <CustomButton
                    width={"100%"}
                    height={"100%"}
                    size={"1.8vw"}
                    radius={"0.4vw"}
                    fontWeight={"400"}
                    text={"+ 물품추가"}
                  ></CustomButton>
                </AddItemButtonBox>
              </ItemHeaderBox>
              {data.itemList.map((item: any, index: number) => {
                return (
                  <ItemComponentBox key={item.id}>
                    <ItemComponent
                      data={item}
                      deleteItem={deleteItem}
                      roomId={data.id}
                    ></ItemComponent>
                  </ItemComponentBox>
                );
              })}
            </ItemListArea>
          </ExpandedBox>
        )}

        <ExpandButtonBox onClick={() => setIsExpanded(!isExpanded)}>
          <ButtonImage>
            <Image
              src={`/img/slider_${isExpanded ? "up" : "down"}_icon.png`}
              width={"100%"}
              height={"4.1vw"}
            ></Image>
          </ButtonImage>
        </ExpandButtonBox>
      </Wrapper>

      {openAddItemModal && (
        <Backdrop>
          <AddItemModal
            onClose={onCloseAddItemModal}
            addNewItem={addNewItem}
          ></AddItemModal>
        </Backdrop>
      )}
    </>
  );
}
